// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty_empty__2BJ9G","text":"Empty_text__2cAtH","icon":"Empty_icon__J6KoI"};